

 <!-- 车位租控 -->
<template>
  <div class="park-control-container">
    <!-- 1. 顶部统计卡片 -->
    <div class="stats-grid">
      <div v-for="(item, index) in summaryCards" :key="index" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value" :style="{ color: item.color }">
          {{ item.value }}
          <span class="unit-icon">{{ item.unit }}</span>
        </div>
      </div>
    </div>

    <!-- 2. 筛选操作栏 -->
    <div class="filter-section">
      <div class="filter-item">
        <span class="label">选择停车场：</span>
        <el-select
          v-model="paId"
          size="small"
          placeholder="请选择"
          style="width: 200px"
          @change="assetChange"
        >
          <el-option
            v-for="item in parkingAreaList"
            :label="item.num"
            :value="item.paId"
            :key="item.paId"
          />
        </el-select>
      </div>
    </div>

    <!-- 3. 图例说明 -->
    <div class="legend-bar">
      <span class="legend-title">图例：</span>
      <div v-for="lg in legendItems" :key="lg.label" class="legend-item">
        <span
          class="color-box"
          :style="{
            backgroundColor: lg.bg,
            borderColor: lg.border || 'transparent',
            borderStyle: lg.border ? 'solid' : 'none',
            borderWidth: '1px',
          }"
        ></span>
        <span class="text">{{ lg.label }}</span>
      </div>
    </div>

    <!-- 4. 车位方块群 (宽度铺满其父容器) -->
    <div class="parking-main-box">
      <div class="parking-grid">
        <div
          v-for="item in parkingSpaceList"
          :key="item.resourceId"
          class="park-square"
          :class="['status-' + item.state]"
          @click="cellClick(item)"
        >
          <div class="park-code">{{ item.num }}</div>
          <div class="park-price" v-if="item.endTime && item.state == 'H'">{{ item.endTime }} </div>
          <div class="park-price" v-if="item.state == 'F'">空置可租</div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="currentTitle + '- 车位详情'"
      :visible.sync="dialogVisible"
      width="40%"
      :max-height="800"
      :before-close="handleClose"
      custom-class="custom-room-dialog"
    >
      <leaseControlMapTab2Modal :details="sectionDetails" />
      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../../utils/dateUtil.js";
import {
  mapValuesToArray,
  isEmptyValue,
  filterEmptyFields,
  commonFormatter,
} from "../../../utils/tool.js";

import { parkingSpaceStatistics, getParkingAreaList, listWithParkingSpace } from '../../../api/assets/occupancyMapApi'
import { getCommunityId } from '@/api/community/communityApi'
import leaseControlMapTab2Modal from "./leaseControlMapTab2Modal.vue";


const TAG = "车位租控";

export default {
  components: {
    leaseControlMapTab2Modal,
  },
  data() {
    return {
      communityId: getCommunityId(),
      currentTitle: "",
      // 控制弹窗是否显示
      dialogVisible: false,
      parkingAreaList:[],
      parkingSpaceList: [],
      paId: "",

      // 顶部汇总统计
      summaryCards: [
        {
          label: "总车位数",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "total",
        },
        {
          label: "已出租",
          value: "",
          unit: "个",
          color: "#67C23A",
          key: "rentedCount",
        },
        {
          label: "空置可租",
          value: "",
          unit: "个",
          color: "#E6A23C",
          key: "availableCount",
        },
        {
          label: "已预订",
          value: "",
          unit: "个",
          color: "#409EFF",
          key: "reservedCount",
        },
        {
          label: "即将到期",
          value: "",
          unit: "个",
          color: "#F56C6C",
          key: "expiringCount",
        },
      ],
      // 图例配置
      legendItems: [
        { label: "已出租", bg: "#52c41a" },
        { label: "空置可租", bg: "#ffffff", border: "#d9d9d9" },
        { label: "已预订", bg: "#ffffff", border: "#1890ff" },
        { label: "即将到期", bg: "#ff4d4f" },
      ],
      // 详情模板
      sectionDetails: [
        {
          key: "baseInfo",
          show: true,
          title: "基本信息",
          items: [
            { key: "resourceName", label: "车位号", value: "" },
            { key: "currentStatus", label: "租赁状态", value: "" },
            { key: "area", label: "面积", value: "" },
            { key: "rentPrice", label: "租金单价(元/月)", value: "" },
            { key: "expiryDate", label: "到期日期", value: "", span: 2 },
          ],
        },
        {
          key: "contract",
          show: true,
          title: "租客信息",
          items: [
            { key: "partyBContact", label: "租客名称", value: "", span: 2 },
            { key: "partyBPhone", label: "联系电话", value: "" },
          ],
        },
      ],
    };
  },

  computed: {
    ...mapState("asset", ["assetList", "resourceListZK"]),
  },

  mounted() {
    this.initParkingArea();
    this.searchStatics();
  },
  methods: {
    ...mapActions("asset", [
      "listWithAssetHandler", // 租控图，车位，广告位，铺位
      "getStatisticsHandler", // 租控图，车位，广告位，铺位
    ]),
    initParkingArea() {
      getParkingAreaList(this.communityId).then(res => {
        this.parkingAreaList = res.data.data;
        this.paId = this.parkingAreaList[0].paId;
      }).then(() => {
        this.search()
      })
    },
    search() {
      const params = { communityId: this.communityId, paId: this.paId };
      listWithParkingSpace(params).then(res => {
        this.parkingSpaceList = res.data.data;
      })
    },

    searchStatics() {
      const params = { communityId: this.communityId };
      parkingSpaceStatistics(params).then((resp) => {
        this.summaryCards =mapValuesToArray(this.summaryCards, resp.data.data);
      });
    },

    assetChange() {
      this.search();
    },

    //----------------------弹窗展示---------------------

    /**
     * 处理弹窗关闭操作
     */
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * 处理弹窗关闭操作
     */
    openDetail() {
      this.dialogVisible = true;
    },

    cellClick(item) {
      console.log(TAG, "cellClick item=", item);
      this.currentTitle = _.get(item, "resourceName");
      this.openDetail();
      this.setDetail(item);
    },

    setDetail(item) {
      const cellObj = { ...item };
      const contract = _.get(cellObj, "contractPageVo");
      Object.assign(cellObj, contract);

      console.log(TAG, "setDetail cellObj=", cellObj);

      const append = {
        expiryDate: formatDate(_.get(cellObj, "expiryDate", ""), "yyyy-MM-dd"),
        currentStatus: commonFormatter(_.get(cellObj, "currentStatus")),
      };

      Object.assign(cellObj, append);

      console.log(TAG, "setDetail cellObj=", cellObj);
      _.each(this.sectionDetails, (detail) => {
        const items = _.get(detail, "items");
        const key = _.get(detail, "key");

        if (key == "contract" && isEmptyValue(contract)) {
          detail.show = false;
        }

        detail.items = mapValuesToArray(items, cellObj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-body: #f5f7fa; // 页面底色
$bg-card: #ffffff; // 卡片背景
$border-color: #ebeef5; // 边框颜色
$text-main: #303133; // 主文本
$text-sub: #909399; // 次要文本

/* 状态颜色 */
$color-green: #52c41a; // 已出租-绿
$color-red: #ff4d4f; // 即将到期-红
$color-blue: #1890ff; // 已预订-蓝
$color-white: #fff; // 空闲-白色
$color-purple: #722ed1; // 装修中 (紫色)
$color-vacant-border: #dcdfe6; // 空置边框
$vacant-border: #dcdfe6; // 空置边框

.park-control-container {
  // padding: 20px;
  // background-color: $bg-body;
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;

  /* 顶部统计卡片 */
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    margin-bottom: 20px;

    .stat-card {
      background: $bg-card;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.01);

      .stat-label {
        font-size: 13px;
        color: $text-sub;
        margin-bottom: 8px;
      }
      .stat-value {
        font-size: 24px;
        font-weight: 500;
        .unit-icon {
          font-size: 16px;
          margin-left: 4px;
        }
      }
    }
  }

  /* 筛选操作栏 */
  .filter-section {
    background: $bg-card;
    padding: 15px 20px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid $border-color;
    display: flex;
    gap: 30px;

    .filter-item {
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        font-weight: bold;
        color: $text-main;
        white-space: nowrap;
      }
    }
  }

  /* 图例栏 */
  .legend-bar {
    background: $bg-card;
    padding: 12px 20px;
    border-bottom: 1px solid $border-color;
    display: flex;
    align-items: center;
    gap: 15px;

    .legend-title {
      font-size: 13px;
      font-weight: bold;
      color: $text-main;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      .color-box {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        display: inline-block;
      }
      .text {
        font-size: 13px;
        color: $text-main;
      }
    }
  }

  /* 车位主容器 */
  .parking-main-box {
    background: $bg-card;
    padding: 24px;
    border-radius: 0 0 8px 8px;
    min-height: calc(100vh - 460px);

    /* 响应式网格：宽度铺满，每行显示的格数随屏幕变化 */
    .parking-grid {
      display: grid;
      // 默认大屏一排 10 个（完全对照原图比例）
      grid-template-columns: repeat(20, 1fr);
      gap: 10px;
      width: 100%;

      .park-square {
        aspect-ratio: 1.3 / 1; // 保持矩形比例
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 5px;
        cursor: pointer;
        transition: transform 0.2s;
        border: 1px solid transparent;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .park-code {
          font-size: 12px;
          font-weight: bold;
          margin-bottom: 2px;
        }
        .park-price,
        .park-date {
          font-size: 10px;
          transform: scale(0.9);
          white-space: nowrap;
        }

        /* 状态样式 */
        // 已出租
        &.status-H {
          background-color: $color-green;
          color: #fff;
        }

        // 即将到期
        &.status-expiring {
          background-color: $color-red;
          color: #fff;
        }

        // 已预定
        &.status-RESERVED {
          background-color: #fff;
          border: 1px solid $color-blue;
          color: $color-blue;
        }
        // 空闲可租
        &.status-F {
          background-color: $color-white;
          border: 1px solid $vacant-border;
          color: #999;
          .park-code {
            color: #555;
          }
        }
      }
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 1400px) {
  .park-control-container .parking-main-box .parking-grid {
    grid-template-columns: repeat(8, 1fr);
  }
}

@media screen and (max-width: 1100px) {
  .park-control-container .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .park-control-container .parking-main-box .parking-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .park-control-container .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .park-control-container .filter-section {
    flex-direction: column;
    gap: 10px;
  }
  .park-control-container .parking-main-box .parking-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

::v-deep .el-dialog__header {
  text-align: left;
}
</style>
